import React from "react";

type StatusVariant =
  | "draft" | "filed" | "under_examination" | "fer_issued" | "fer_responded" |"hearing_scheduled"| "allowed" | "granted" | "renewal_due" | "renewed" |"abandoned" | "pending" | "in_progress" | "under_review" | "completed"
  | "overdue" | "paid" | "sent" | "void" | "active" | "inactive" | "todo" | "blocked" | "done" | "cancelled";

interface StatusBadgeProps {
  status: StatusVariant | string;
  size?: "sm" | "md";
  dot?: boolean;
}

const statusConfig: Record<string, { label: string; className: string }> = {
  draft: { label: "Draft", className: "bg-slate-100 text-slate-600 border-slate-200" },
  filed: { label: "Filed", className: "bg-blue-50 text-blue-700 border-blue-200" },
  under_examination: { label: "Under Examination", className: "bg-indigo-50 text-indigo-700 border-indigo-200" },
  fer_issued: { label: "FER Issued", className: "bg-orange-50 text-orange-700 border-orange-200" },
  fer_responded: { label: "FER Responded", className: "bg-yellow-50 text-yellow-700 border-yellow-200" },
  hearing_scheduled: { label: "Hearing Scheduled", className: "bg-purple-50 text-purple-700 border-purple-200" },
  allowed: { label: "Allowed", className: "bg-teal-50 text-teal-700 border-teal-200" },
  granted: { label: "Granted", className: "bg-green-50 text-green-700 border-green-200" },
  renewal_due: { label: "Renewal Due", className: "bg-red-50 text-red-700 border-red-200" },
  renewed: { label: "Renewed", className: "bg-emerald-50 text-emerald-700 border-emerald-200" },
  pending_examination: { label: "Pending Examination", className: "bg-amber-50 text-amber-700 border-amber-200" },
  approved: { label: "Approved", className: "bg-teal-50 text-teal-700 border-teal-200" },
  rejected: { label: "Rejected", className: "bg-red-50 text-red-700 border-red-200" },
  abandoned: { label: "Abandoned", className: "bg-gray-100 text-gray-500 border-gray-200" },
  pending: { label: "Pending", className: "bg-amber-50 text-amber-700 border-amber-200" },
  in_progress: { label: "In Progress", className: "bg-blue-50 text-blue-700 border-blue-200" },
  under_review: { label: "Under Review", className: "bg-violet-50 text-violet-700 border-violet-200" },
  completed: { label: "Completed", className: "bg-green-50 text-green-700 border-green-200" },
  overdue: { label: "Overdue", className: "bg-red-50 text-red-700 border-red-200" },
  paid: { label: "Paid", className: "bg-green-50 text-green-700 border-green-200" },
  sent: { label: "Sent", className: "bg-blue-50 text-blue-700 border-blue-200" },
  void: { label: "Void", className: "bg-gray-100 text-gray-500 border-gray-200" },
  active: { label: "Active", className: "bg-green-50 text-green-700 border-green-200" },
  inactive: { label: "Inactive", className: "bg-gray-100 text-gray-500 border-gray-200" },
  todo: { label: "To Do", className: "bg-amber-50 text-amber-700 border-amber-200" },
  blocked: { label: "Blocked", className: "bg-red-50 text-red-700 border-red-200" },
  done: { label: "Done", className: "bg-green-50 text-green-700 border-green-200" },
  cancelled: { label: "Cancelled", className: "bg-gray-100 text-gray-500 border-gray-200" },
};

export default function StatusBadge({ status, size = "md", dot = false }: StatusBadgeProps) {
  const config = statusConfig[status] ?? {
    label: status.replace(/_/g, " ").replace(/\b\w/g, (c) => c.toUpperCase()),
    className: "bg-gray-100 text-gray-600 border-gray-200",
  };

  return (
    <span
      className={`
        inline-flex items-center justify-center gap-1 font-500 border rounded-full max-w-full
        ${size === "sm" ? "text-[10px] px-2.5 py-0.5 min-w-[60px]" : "text-[11px] px-3 py-0.5 min-w-[70px]"}
        ${config.className}
      `}
      title={config.label}
    >
      {dot && <span className="w-1.5 h-1.5 rounded-full flex-shrink-0 bg-current opacity-70" />}
      <span className="truncate">{config.label}</span>
    </span>
  );
}
